import { render, staticRenderFns } from "./HealthCodeRecordVerification.vue?vue&type=template&id=6f517eb2&scoped=true"
import script from "./HealthCodeRecordVerification.vue?vue&type=script&lang=js"
export * from "./HealthCodeRecordVerification.vue?vue&type=script&lang=js"
import style0 from "./HealthCodeRecordVerification.vue?vue&type=style&index=0&id=6f517eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f517eb2",
  null
  
)

export default component.exports